import React from "react";
import { StyledAnchor } from "./_styled";
import {
  Link,
  ContentFormatter,
} from "discover.medical.react-component-library";

const processHfcLink = (children, handleClick) => (
  <StyledAnchor
    linkComponent={Link}
    data-testid="hfc-anchor"
    onClick={handleClick}
  >
    {children}
  </StyledAnchor>
);

export default function useHFCProcessor({ handleHFCDialogOpen, hfcData }) {
  const handleClick = (e) => {
    e.preventDefault();
    handleHFCDialogOpen();
  };

  const preprocessorConfig = {
    replaceChildren: false,
    shouldProcessNode: (node) => {
      return node.attribs?.["class"] === "hospitalistPanel";
    },
    processNode: (_node, children) => processHfcLink(children, handleClick),
  };
  const preProcessors = [preprocessorConfig];

  const processHfc = () => (
    <ContentFormatter preProcessors={preProcessors}>
      {hfcData.content}
    </ContentFormatter>
  );

  return { processHfc };
}
